import React, { useMemo } from 'lib/react';
import {
  EVGrid,
  EVRoofIcon,
  makeStyles,
} from 'lib/components';
import { useSelector } from 'react-redux';
import { STRUCTURE_TYPES } from 'constants/AppConstants';
import * as productCategories from '../Product/ProductList.constants';
import PrimaryProductTemplate from '../Product/PrimaryProduct.template';

const useStyles = makeStyles((theme) => ({
  header: {
    display: 'flex',
    lineHeight: '24px',
    padding: '0px',
    margin: '0px',
    fontSize: '16px',
    color: theme.evPalette.ocean[700],
    '& .myev-MuiExpansionPanelSummary-content': {
      margin: '0px',
      '& .myev-MuiGrid-container': {
        gap: '10px',
      },
    },
    '& .myev-MuiExpansionPanelSummary-expandIcon.Mui-expanded': {
      transform: 'rotate(90deg)',
    },
    '&.Mui-expanded': { minHeight: 'unset' },
  },
  select: {
    height: '44px',
  },
}));

function ProductsSection() {
  const classes = useStyles();
  const userProducts = useSelector(({ userData }) => userData.userProducts);
  const blueprintProducts = useMemo(
    () => userProducts[STRUCTURE_TYPES[1]]?.PrimaryProducts.filter((product) => product.ProductID === 57),
    [userProducts],
  );

  return (
    <EVGrid style={{ flex: 1 }}>
      <PrimaryProductTemplate
        name={productCategories.ROOF_PRODUCTS}
        products={blueprintProducts || []}
        icon={<EVRoofIcon className={classes.iconStyle} />}
        selectedProductKey="selectedPrimaryProduct"
        selectedDeliveryProductKey="selectedPrimaryDeliveryProduct"
        selectComponentType="radio"
        showAsExpansionPanel={false}
      />
    </EVGrid>
  );
}

export default ProductsSection;
